export default __webpack_public_path__ + "static/media/3a746c3df587a3b1b53c927f749e17b7.svg";